(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/frejaeid-poll.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/frejaeid-poll.js');

'use strict';

const {
  frejaeIdPollType,
  appWaitStatus,
  loginType
} = svs.playerLoginReact.constants;
const {
  setPlayerLoginType,
  setIsLogin
} = svs.playerLoginReact.store.playerloginreactactions;
const {
  FrejaeIdStart,
  FrejaeIdWaiting
} = svs.playerLoginReact.frejaeid.components;
const {
  UpdateHeader
} = svs.playerLoginReact.sharedComponents;

const FrejaeIdPoll = _ref => {
  let {
    isLogin = true,
    pollState = frejaeIdPollType.BEFORE_POLL,
    frejaeIdPollWait = appWaitStatus.WAITING_QRCODE
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  React.useEffect(() => {
    dispatch(setPlayerLoginType(loginType.FREJAEID));
    dispatch(setIsLogin(isLogin));
    UpdateHeader.updateHeader(isLogin ? 'Logga in' : 'Bli kund');
  }, [dispatch, isLogin]);
  return React.createElement(React.Fragment, null, pollState === frejaeIdPollType.BEFORE_POLL && React.createElement(FrejaeIdStart, {
    isLogin: isLogin
  }), pollState === frejaeIdPollType.WAITING_POLL && React.createElement(FrejaeIdWaiting, {
    frejaeIdPollWait: frejaeIdPollWait,
    isLogin: isLogin
  }));
};
svs.playerLoginReact.frejaeid.FrejaeIdPoll = FrejaeIdPoll;

 })(window);